<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 58">
  <defs>
  </defs>
  <g id="Laag_2" data-name="Laag 2">
    <g id="Laag_1-2" data-name="Laag 1" class='kruis'>
      <circle cx="29" cy="29" r="28" fill="#fff"/>
      <path class="cls-2" d="M29 58a29 29 0 1129-29 29 29 0 01-29 29zm0-56a27 27 0 1027 27A27 27 0 0029 2z"/>
      <path class="cls-2 kruis-streep" d="M20.06 28h17.88v2H20.06z"/>
      <path class="cls-2 kruis-streep" d="M28 20.06h2v17.88h-2z"/>
    </g>
  </g>
</svg>
</template>